module.exports = __webpack_public_path__ + "static/img/7-易宝软件.b2688463.png";